import { NoDataAvailable } from "@pmag/ui-components";
import { type GQLComponentGroupParentGenericFragment } from "@src/graphql.generated";
import { filterComponentGroupArrayBySearchTerm } from "@src/pages/componentGroupOverview/ComponentGroupOverviewPage.utils";
import { CardGrid } from "@src/pages/componentGroupOverview/components/cardGrid/CardGrid";
import { CardGridSkeleton } from "@src/pages/componentGroupOverview/components/cardGrid/CardGridSkeleton";
import { type FunctionComponent, useMemo } from "react";

export const dataTestId = {
    loadingSkeleton: "sparePartsFinder.componentGroupOverview.engineTab.loadingSkeleton",
    InlineError: "sparePartsFinder.componentGroupOverview.engineTab.InlineError",
    NoDataAvailable: "sparePartsFinder.componentGroupOverview.engineTab.NoDataAvailable",
};

export interface EngineTabProps {
    brandColor?: string | null;
    data: GQLComponentGroupParentGenericFragment[];
    loading: boolean;
    searchTerm: string;
}

export const EngineTab: FunctionComponent<EngineTabProps> = ({ searchTerm, brandColor, data, loading }) => {
    const filteredComponentGroups = useMemo(() => {
        if (searchTerm != "" && data.length > 0) {
            return filterComponentGroupArrayBySearchTerm(data, searchTerm);
        }

        return data;
    }, [data, searchTerm]);

    if (loading) return <CardGridSkeleton data-testid={dataTestId.loadingSkeleton} />;

    if (filteredComponentGroups.length === 0) return <NoDataAvailable data-testid={dataTestId.NoDataAvailable} />;

    return <CardGrid componentGroupArray={filteredComponentGroups} brandColor={brandColor} />;
};
